export const validationRule = {
    required: "required",
    email: "email",
    phone: "phone",
    dropDown: "dropDown",
    max: "max",
    min: "min",
};

export const compName = {
    budget: "Budget",
    netStly: "NetStly",
    onTheBook: "OnTheBook",
    reservationActivity: "ReservationActivity",
    totalLy: "TotalLy",
    userForecast: "UserForecast",
    oneDay: "OneDay",
    oneDayForecastChange: "OneDayForecastChange",

    threeDayForecastChange: "ThreeDayForecastChange",
    threeDay: "ThreeDay",

    sevenDay: "SevenDay",
    sevenDayForecastChange: "SevenDayForecastChange",
    group: "Group",
    groupLastYear: "GroupLastYear",
    transient: "Transient",
    transientLastYear: "TransientLastYear",
    org: "ORG",
    barBasedStats: "BarBasedStats",
    pickupFrom: "PickUpFrom",
    pricingAndForecast: "PricingAndForecast",
    heatMap: "HeatMap",
    CancellationHeatMap: "CancellationHeatMap",
    widgetBudgetGraph: "WidgetBudgetGraph",
    spiderForecast: "SpiderForecast",
    rmsForecast: "RMSForecast",
    choiceRes: "ChoiceRes",
    mstReservation: "MstReservation",
    dailyDataTransaction: "DailyDataTransaction",
    emaForecast: "EMAForecast",
    annualSummaryChart: "AnnualSummaryChart",
    forecastChart: "ForecastChart",
    pickupChart: "PickupChart",
    groupChart: "GroupChart",
    GroupWash: "GroupWash",
    RecommendedRate: "RecommendedRate",
    bookingPaceChart: "BookingPace",
    marketSegmentChart: "MarketSegmentChart",
    DayOfWeekSegmentMix: "DayOfWeekSegmentMix",
    widgetChoiceOccupancy: "WidgetChoiceOccupancy",
    widgetHotelKeyReservation: "WidgetHotelKeyReservation",
    widgetHotelKeyOccupancySnapshot: "WidgetHotelKeyOccupancySnapshot",
    widgetBestWesternGuestName: "WidgetBestWesternGuestName",
    widgetBestWesternReservationAgent: "WidgetBestWesternReservationAgent",
    widgetBestWesternReservationForecast: "WidgetBestWesternReservationForecast",
    widgetBestWesternRoomMaintaince: "WidgetBestWesternRoomMaintaince",
    widgetChoiceCancelationSummary: "WidgetChoiceCancelationSummary",
    adrVsRateChart: "AdrVsRateChart",
    widgetPickup: "WidgetPickup",
    bookingPaceTable: "BookingPaceTable",
    annualSummary: "AnnualSummary",
    widgetChoiceBusinessOTB: "WidgetChoiceBusinessOTB",
    widgetChoiceRevenue: "WidgetChoiceRevenue",
    marketSegmentDayByDay: "MarketSegmentDayByDay",
    marketSegmentRoomType: "MarketSegmentRoomType",
    ratePlanDayByDay: "RatePlanDayByDay",
    dynamicPickup: "DynamicPickup",
    losDayOfWeek: "LosDayOfWeek",
    top10Chart: "Top10Chart",
    dayByDayGroup: "DayByDayGroup",
    sevenDayBookingReservation: "SevenDayBookingReservation",
    sevenDayBookingExpected: "SevenDayBookingExpected",
    sevenDayBookingPace: "SevenDayBookingPace",
    sevenWeekBookingPace: "SevenWeekBookingPace",
    lengthOfStay: "LengthOfStay",
    emaForecastV2: "EmaForecastV2",
    emaForecastV3: "EmaForecastV3",
    forecastCommon: "ForecastCommon",
    pickupCommon: "PickupCommon",
    groupCommon: "GroupCommon",
    revYoYChart: "RevYoYChart",
    segmentDrillDown: "SegmentDrillDown",
    roomTypeDrillDown: "RoomTypeDrillDown",
    ninetyDayOutlook: "NinetyDayOutlook",
    lastYearAndForecast: "LastYearAndForecast",
    annSummaryCancellation: "AnnSummaryCancellation",
    cancellationPace: "CancellationPace",
    account: "Account",
    cyCancellationBookingRevLoss: "CyCancellationBookingRevLoss",
    lyCancellationBookingRevLoss: "LyCancellationBookingRevLoss",
    stlyCancellationBookingRevLoss: "StlyCancellationBookingRevLoss",
    cy2CancellationBookingRevLoss: "Cy2CancellationBookingRevLoss",
    annCancellationSummary: "AnnCancellationSummary",
    monthlyCancellationPace: "MonthlyCancellationPace",
    monthlyCancellationPaceChart: "MonthlyCancellationPaceChart",
    ninetyDaySegment: "NinetyDaySegment",
    cancellationDayByDay: "CancellationDayByDay",
    top50ByRevenue: "Top50ByRevenue",
    YieldRadar: "YieldRadar",
    dailyDataForEmail: "DailyDataForEmail",
    DailyAndMonthlyData: "DailyAndMonthlyData",
    weeklyDataForEmail: "WeeklyDataForEmail",
    monthlyDataForEmail: "MonthlyDataForEmail",
    runningStrReport: "RunningStrReport",
    weeklyStrReport: "WeeklyStrReport",
    strAnalysis: "StrAnalysis",
    strDayByDay: "StrDayByDay",
    monthlySegmentDrilldown: "MonthlySegmentDrilldown",
    pastDynamicPickup: "PastDynamicPickup",
    bookingPaceComparisonChart: "BookingPaceComparisonChart",
    thirtyDayPickup: "ThirtyDayPickup",
    bookingPaceComparison: "BookingPaceComparison",
    commentWidget: "CommentWidget",
    forecastUsing90DayPickup: "ForecastUsing90DayPickup",
    crmRevnueByCompany: "CrmRevnueByCompany",
    crmRevenueByRoomType: "CrmRevenueByRoomType",
    crmRevenueByMarketSegment: "CrmRevenueByMarketSegment",
    forecastvsOtbChart: "ForecastvsOtbChart",
    perityCheck: "PerityCheck",
    channelMonthlyDrilldown: "ChannelMonthlyDrilldown",
    dayByDayChannel: "Channel",
    crmCancellationActivity: "CrmCancellationActivity",
    crmCompanyDrilldown: "CrmCompanyDrilldown",
    crmArrialDeparture: "CrmArrialDeparture",
    rateShopBenchmarking: "RateShopBenchmarking",
    toolRateShop: "ToolRateShop",
    toolReminder: "ToolReminder",
    toolEvent: "ToolEvent",
    toolRateIq: "ToolRateIq",
    toolDisplacementCalculator: "ToolDisplacementCalculator",
    toolPerityCheck: "ToolPerityCheck",
    heatMapdaywise: "HeatMapdaywise",
    eventStretegyWidget: "EventStretegyWidget",
    pastForecastChart: "PastForecastChart",
    weatherWidget: "WeatherWidget",
    bookingPaceForecastComparison: "BookingPaceForecastComparison",
    bookingPaceMonthlyForecast: "BookingPaceMonthlyForecast",
    dynamicForecastUsingNinentyDayPickup: "DynamicForecastUsingNinentyDaysPickup",
    rateShopChart: "RateShopChart",
    seasonalityAnalysis: "SeasonalityAnalysis",
    marketSegmentWiseReservation: "MarketSegmentWiseReservation",
    monthlyBookingWindow: "MonthlyBookingWindow",
    dayByDayBookingWindow: "DayByDayBookingWindow",
    googleRatings: "GoogleRatings",
    analyticsReview: "AnalyticsReview",
    analyticsRates: "AnalyticsRates",
    analyticsRatesCount: "AnalyticsRatesCount",
    analyticsSentimateReview: "AnalyticsSentimateReview",
    strategyByReservation: "StrategyByReservation",
    forecastUsingNinetyDayPickupNew: "ForecastUsingNinetyDayPickupNew",
    bookingCurveNew: "BookingCurveNew",
    PickupAnalysis: "PickupAnalysis",
    PerformanceADRMonitor: "PerformanceADRMonitor",
    PricingLadder: "PricingLadder",
    PricingSimulator: "PricingSimulator",

    WordCloudChart: "WordCloudChart",

    ADRRoomSoldOHLC: "ADRRoomSoldOHLC",
    ADRRoomSoldMarketSegmentMixAnalysis: "ADRRoomSoldMarketSegmentMixAnalysis",
    ProjectedOccupancyTrend: "ProjectedOccupancyTrend",
    PropertyOverview: "PropertyOverview",
    RMCopilot: "RMCopilot",
    CompsetVariance: "CompsetVariance",
    RateShopPayment: "RateShopPayment",
    LowDemandDates: "LowDemandDates",
    HighDemandDates: "HighDemandDates",
    EventStrategy: "EventStrategy",
    PaceIQ: "PaceIQ",
    BookingPaceNew: "BookingPaceNew",
    DemandCalender: "DemandCalender",
    MarketSegmentDrilldownChart: "MarketSegmentDrilldownChart",
    RNXAnalysis1: "RNXAnalysis1",
    RNXAnalysis2: "RNXAnalysis2",
    RNXAnalysis3: "RNXAnalysis3",
    RNXisell: "RNXisell",
    RNXSOTMPickup: "RNXSOTMPickup",
    RNXWOWPickup: "RNXWOWPickup",
    CurrentWeekOnTheBooks: "CurrentWeekOnTheBooks",
    CurrentNextYearOnTheBooks: "CurrentNextYearOnTheBooks",
    RecapReport: "RecapReport",
    TransientGroupOnTheBooks: "TransientGroupOnTheBooks",
    SegmentsWise: "SegmentsWise",

    RNXAnalysis1_Month: "RNXAnalysis1_Month",
    RNXAnalysis1_Day: "RNXAnalysis1_Day",
    RNXAnalysis2_RevenuAdrNight: "RNXAnalysis2_RevenuAdrNight",
    RNXAnalysis2_RevenueVolumeByChannels: "RNXAnalysis2_RevenueVolumeByChannels",
    RNXAnalysis2_BookingPace: "RNXAnalysis2_BookingPace",
    RNXAnalysis2_RoomNightVolumeByChannels: "RNXAnalysis2_RoomNightVolumeByChannels",
    RNXAnalysis2_RateBand: "RNXAnalysis2_RateBand",
    RNXAnalysis2_RoomNightRateBand: "RNXAnalysis2_RoomNightRateBand",
    RNXAnalysis2_RatePaceGraph: "RNXAnalysis2_RatePaceGraph",
    RNXSOTMPickup_CurrentYear: "RNXSOTMPickup_CurrentYear",
    RNXSOTMPickup_STLY: "RNXSOTMPickup_STLY",

    Patterns_RevenuePerDayByDow: "Patterns_RevenuePerDayByDow",
    Patterns_RoomNightsPerDayByDow: "Patterns_RoomNightsPerDayByDow",
    Patterns_ADR: "Patterns_ADR",
    Patterns_DOWContributionRevenue: "Patterns_DOWContributionRevenue",
    Patterns_DOWContributionRoom: "Patterns_DOWContributionRoom",
    Patterns_DOWPatternADR: "Patterns_DOWPatternADR",
    Patterns_ArrivalVSStayThisYear: "Patterns_ArrivalVSStayThisYear",
    Patterns_ArrivalVSStayLastYear: "Patterns_ArrivalVSStayLastYear",
    Patterns_LengthOfStayPatterns: "Patterns_LengthOfStayPatterns",

    CMBookingWindowActivity: "CMBookingWindowActivity",
    CMBookingWindow: "CMBookingWindow",
    CMCancellationHeatmap: "CMCancellationHeatmap",

    CMChannel: "CMChannel",
    GroupIQ: "GroupIQ",

    ChannelMix: "ChannelMix",
    EventsAndCompressionRadar: "EventsAndCompressionRadar",
    MarketShare: "MarketShare",
    PickupAndPace: "PickupAndPace",
    RateParity: "RateParity",
    RGIByDayofWeek: "RGIByDayofWeek",
    ThirtyDayCommandView: "ThirtyDayCommandView",
    CancellationExposure: "CancellationExposure",
    GroupBlocksOnHighDemandDates: "GroupBlocksOnHighDemandDates",
    BookingWindowNext30dArrivals: "BookingWindowNext30dArrivals",

    // Tools Component convert into Widgets
    RmBenchMarking: "RmBenchMarking",
    DisplacementCalc: "DisplacementCalc",
    RMPerityCheck: "RMPerityCheck",
    DemandScore: "DemandScore",
    PriceQualityInsights: "PriceQualityInsights",
    WhatIfPricingSimulator: "WhatIfPricingSimulator",
    BudgetSimulator: "BudgetSimulator",
    UserSimulator: "UserSimulator",
    RMRateShop: "RMRateShop",
    RMRateIq: "RMRateIq",

    AnnualSummaryDrilldown: "AnnualSummaryDrilldown",
    PromoRadar: "PromoRadar",
    PricingEngine: "PricingEngine",
};

export const colValue = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

export const week = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
];

export const month = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];

export const widgetData = [
    {
        noofcol: 1,
        rowtitle: "",
        data: [
            {
                comp: "",
                col: "col-12",
                widgetid: 0,
                orderno: 0,
                rowno: 0,
                colno: 0,
                snapshotwidgetid: 0,
                setting: "",
            },
        ],
        boxDesign: (
            <>
                <div className="gridSelectionBox"></div>
            </>
        ),
    },
    {
        noofcol: 2,
        rowtitle: "",
        data: [
            {
                comp: "",
                col: "col-6",
                widgetid: 0,
                orderno: 0,
                rowno: 0,
                colno: 0,
                snapshotwidgetid: 0,
                setting: "",
            },
            {
                comp: "",
                col: "col-6",
                widgetid: 0,
                orderno: 0,
                rowno: 0,
                colno: 0,
                snapshotwidgetid: 0,
                setting: "",
            },
        ],
        boxDesign: (
            <>
                <div className="gridSelectionBox"></div>
                <div className="gridSelectionBox"></div>
            </>
        ),
    },
    {
        noofcol: 3,
        rowtitle: "",
        data: [
            {
                comp: "",
                col: "col-4",
                widgetid: 0,
                orderno: 0,
                rowno: 0,
                colno: 0,
                snapshotwidgetid: 0,
                setting: "",
            },
            {
                comp: "",
                col: "col-4",
                widgetid: 0,
                orderno: 0,
                rowno: 0,
                colno: 0,
                snapshotwidgetid: 0,
                setting: "",
            },
            {
                comp: "",
                col: "col-4",
                widgetid: 0,
                orderno: 0,
                rowno: 0,
                colno: 0,
                snapshotwidgetid: 0,
                setting: "",
            },
        ],
        boxDesign: (
            <>
                <div className="gridSelectionBox"></div>
                <div className="gridSelectionBox"></div>
                <div className="gridSelectionBox"></div>
            </>
        ),
    },
    {
        noofcol: 4,
        rowtitle: "",
        data: [
            {
                comp: "",
                col: "col-3",
                widgetid: 0,
                orderno: 0,
                rowno: 0,
                colno: 0,
                snapshotwidgetid: 0,
                setting: "",
            },
            {
                comp: "",
                col: "col-3",
                widgetid: 0,
                orderno: 0,
                rowno: 0,
                colno: 0,
                snapshotwidgetid: 0,
                setting: "",
            },
            {
                comp: "",
                col: "col-3",
                widgetid: 0,
                orderno: 0,
                rowno: 0,
                colno: 0,
                snapshotwidgetid: 0,
                setting: "",
            },
            {
                comp: "",
                col: "col-3",
                widgetid: 0,
                orderno: 0,
                rowno: 0,
                colno: 0,
                snapshotwidgetid: 0,
                setting: "",
            },
        ],
        boxDesign: (
            <>
                <div className="gridSelectionBox"></div>
                <div className="gridSelectionBox"></div>
                <div className="gridSelectionBox"></div>
                <div className="gridSelectionBox"></div>
            </>
        ),
    },
    {
        noofcol: 2,
        rowtitle: "",
        data: [
            {
                comp: "",
                col: "col-4",
                widgetid: 0,
                orderno: 0,
                rowno: 0,
                colno: 0,
                snapshotwidgetid: 0,
                setting: "",
            },
            {
                comp: "",
                col: "col-8",
                widgetid: 0,
                orderno: 0,
                rowno: 0,
                colno: 0,
                snapshotwidgetid: 0,
                setting: "",
            },
        ],
        boxDesign: (
            <>
                <div className="gridSelectionBox gridSelectionBoxSm"></div>
                <div className="gridSelectionBox"></div>
            </>
        ),
    },
    {
        noofcol: 2,
        rowtitle: "",
        data: [
            {
                comp: "",
                col: "col-8",
                widgetid: 0,
                orderno: 0,
                rowno: 0,
                colno: 0,
                snapshotwidgetid: 0,
                setting: "",
            },
            {
                comp: "",
                col: "col-4",
                widgetid: 0,
                orderno: 0,
                rowno: 0,
                colno: 0,
                snapshotwidgetid: 0,
                setting: "",
            },
        ],
        boxDesign: (
            <>
                <div className="gridSelectionBox "></div>
                <div className="gridSelectionBox gridSelectionBoxSm"></div>
            </>
        ),
    },
    {
        noofcol: 3,
        rowtitle: "",
        data: [
            {
                comp: "",
                col: "col-6",
                widgetid: 0,
                orderno: 0,
                rowno: 0,
                colno: 0,
                snapshotwidgetid: 0,
                setting: "",
            },
            {
                comp: "",
                col: "col-3",
                widgetid: 0,
                orderno: 0,
                rowno: 0,
                colno: 0,
                snapshotwidgetid: 0,
                setting: "",
            },
            {
                comp: "",
                col: "col-3",
                widgetid: 0,
                orderno: 0,
                rowno: 0,
                colno: 0,
                snapshotwidgetid: 0,
                setting: "",
            },
        ],
        boxDesign: (
            <>
                <div className="gridSelectionBox "></div>
                <div className="gridSelectionBox gridSelectionBoxSm"></div>
                <div className="gridSelectionBox gridSelectionBoxSm"></div>
            </>
        ),
    },
    {
        noofcol: 3,
        rowtitle: "",
        data: [
            {
                comp: "",
                col: "col-3",
                widgetid: 0,
                orderno: 0,
                rowno: 0,
                colno: 0,
                snapshotwidgetid: 0,
                setting: "",
            },
            {
                comp: "",
                col: "col-3",
                widgetid: 0,
                orderno: 0,
                rowno: 0,
                colno: 0,
                snapshotwidgetid: 0,
                setting: "",
            },
            {
                comp: "",
                col: "col-6",
                widgetid: 0,
                orderno: 0,
                rowno: 0,
                colno: 0,
                snapshotwidgetid: 0,
                setting: "",
            },
        ],
        boxDesign: (
            <>
                <div className="gridSelectionBox gridSelectionBoxSm"></div>
                <div className="gridSelectionBox gridSelectionBoxSm"></div>
                <div className="gridSelectionBox "></div>
            </>
        ),
    },
    {
        noofcol: 3,
        rowtitle: "",
        data: [
            {
                comp: "",
                col: "col-3",
                widgetid: 0,
                orderno: 0,
                rowno: 0,
                colno: 0,
                snapshotwidgetid: 0,
                setting: "",
            },
            {
                comp: "",
                col: "col-6",
                widgetid: 0,
                orderno: 0,
                rowno: 0,
                colno: 0,
                snapshotwidgetid: 0,
                setting: "",
            },
            {
                comp: "",
                col: "col-3",
                widgetid: 0,
                orderno: 0,
                rowno: 0,
                colno: 0,
                snapshotwidgetid: 0,
                setting: "",
            },
        ],
        boxDesign: (
            <>
                <div className="gridSelectionBox gridSelectionBoxSm"></div>
                <div className="gridSelectionBox "></div>
                <div className="gridSelectionBox gridSelectionBoxSm"></div>
            </>
        ),
    },
];
export const Time = [
    "12:00 AM",
    "12:05 AM",
    "12:10 AM",
    "12:15 AM",
    "12:20 AM",
    "12:25 AM",
    "12:30 AM",
    "12:35 AM",
    "12:40 AM",
    "12:45 AM",
    "12:50 AM",
    "12:55 AM",
    "01:00 AM",
    "01:05 AM",
    "01:10 AM",
    "01:15 AM",
    "01:20 AM",
    "01:25 AM",
    "01:30 AM",
    "01:35 AM",
    "01:40 AM",
    "01:45 AM",
    "01:50 AM",
    "01:55 AM",
    "02:00 AM",
    "02:05 AM",
    "02:10 AM",
    "02:15 AM",
    "02:20 AM",
    "02:25 AM",
    "02:30 AM",
    "02:35 AM",
    "02:40 AM",
    "02:45 AM",
    "02:50 AM",
    "02:55 AM",
    "03:00 AM",
    "03:05 AM",
    "03:10 AM",
    "03:15 AM",
    "03:20 AM",
    "03:25 AM",
    "03:30 AM",
    "03:35 AM",
    "03:40 AM",
    "03:45 AM",
    "03:50 AM",
    "03:55 AM",
    "04:00 AM",
    "04:05 AM",
    "04:10 AM",
    "04:15 AM",
    "04:20 AM",
    "04:25 AM",
    "04:30 AM",
    "04:35 AM",
    "04:40 AM",
    "04:45 AM",
    "04:50 AM",
    "04:55 AM",
    "05:00 AM",
    "05:05 AM",
    "05:10 AM",
    "05:15 AM",
    "05:20 AM",
    "05:25 AM",
    "05:30 AM",
    "05:35 AM",
    "05:40 AM",
    "05:45 AM",
    "05:50 AM",
    "05:55 AM",
    "06:00 AM",
    "06:05 AM",
    "06:10 AM",
    "06:15 AM",
    "06:20 AM",
    "06:25 AM",
    "06:30 AM",
    "06:35 AM",
    "06:40 AM",
    "06:45 AM",
    "06:50 AM",
    "06:55 AM",
    "07:00 AM",
    "07:05 AM",
    "07:10 AM",
    "07:15 AM",
    "07:20 AM",
    "07:25 AM",
    "07:30 AM",
    "07:35 AM",
    "07:40 AM",
    "07:45 AM",
    "07:50 AM",
    "07:55 AM",
    "08:00 AM",
    "08:05 AM",
    "08:10 AM",
    "08:15 AM",
    "08:20 AM",
    "08:25 AM",
    "08:30 AM",
    "08:35 AM",
    "08:40 AM",
    "08:45 AM",
    "08:50 AM",
    "08:55 AM",
    "09:00 AM",
    "09:05 AM",
    "09:10 AM",
    "09:15 AM",
    "09:20 AM",
    "09:25 AM",
    "09:30 AM",
    "09:35 AM",
    "09:40 AM",
    "09:45 AM",
    "09:50 AM",
    "09:55 AM",
    "10:00 AM",
    "10:05 AM",
    "10:10 AM",
    "10:15 AM",
    "10:20 AM",
    "10:25 AM",
    "10:30 AM",
    "10:35 AM",
    "10:40 AM",
    "10:45 AM",
    "10:50 AM",
    "10:55 AM",
    "11:00 AM",
    "11:05 AM",
    "11:10 AM",
    "11:15 AM",
    "11:20 AM",
    "11:25 AM",
    "11:30 AM",
    "11:35 AM",
    "11:40 AM",
    "11:45 AM",
    "11:50 AM",
    "11:55 AM",
    "12:00 PM",
    "12:05 PM",
    "12:10 PM",
    "12:15 PM",
    "12:20 PM",
    "12:25 PM",
    "12:30 PM",
    "12:35 PM",
    "12:40 PM",
    "12:45 PM",
    "12:50 PM",
    "12:55 PM",
    "01:00 PM",
    "01:05 PM",
    "01:10 PM",
    "01:15 PM",
    "01:20 PM",
    "01:25 PM",
    "01:30 PM",
    "01:35 PM",
    "01:40 PM",
    "01:45 PM",
    "01:50 PM",
    "01:55 PM",
    "02:00 PM",
    "02:05 PM",
    "02:10 PM",
    "02:15 PM",
    "02:20 PM",
    "02:25 PM",
    "02:30 PM",
    "02:35 PM",
    "02:40 PM",
    "02:45 PM",
    "02:50 PM",
    "02:55 PM",
    "03:00 PM",
    "03:05 PM",
    "03:10 PM",
    "03:15 PM",
    "03:20 PM",
    "03:25 PM",
    "03:30 PM",
    "03:35 PM",
    "03:40 PM",
    "03:45 PM",
    "03:50 PM",
    "03:55 PM",
    "04:00 PM",
    "04:05 PM",
    "04:10 PM",
    "04:15 PM",
    "04:20 PM",
    "04:25 PM",
    "04:30 PM",
    "04:35 PM",
    "04:40 PM",
    "04:45 PM",
    "04:50 PM",
    "04:55 PM",
    "05:00 PM",
    "05:05 PM",
    "05:10 PM",
    "05:15 PM",
    "05:20 PM",
    "05:25 PM",
    "05:30 PM",
    "05:35 PM",
    "05:40 PM",
    "05:45 PM",
    "05:50 PM",
    "05:55 PM",
    "06:00 PM",
    "06:05 PM",
    "06:10 PM",
    "06:15 PM",
    "06:20 PM",
    "06:25 PM",
    "06:30 PM",
    "06:35 PM",
    "06:40 PM",
    "06:45 PM",
    "06:50 PM",
    "06:55 PM",
    "07:00 PM",
    "07:05 PM",
    "07:10 PM",
    "07:15 PM",
    "07:20 PM",
    "07:25 PM",
    "07:30 PM",
    "07:35 PM",
    "07:40 PM",
    "07:45 PM",
    "07:50 PM",
    "07:55 PM",
    "08:00 PM",
    "08:05 PM",
    "08:10 PM",
    "08:15 PM",
    "08:20 PM",
    "08:25 PM",
    "08:30 PM",
    "08:35 PM",
    "08:40 PM",
    "08:45 PM",
    "08:50 PM",
    "08:55 PM",
    "09:00 PM",
    "09:05 PM",
    "09:10 PM",
    "09:15 PM",
    "09:20 PM",
    "09:25 PM",
    "09:30 PM",
    "09:35 PM",
    "09:40 PM",
    "09:45 PM",
    "09:50 PM",
    "09:55 PM",
    "10:00 PM",
    "10:05 PM",
    "10:10 PM",
    "10:15 PM",
    "10:20 PM",
    "10:25 PM",
    "10:30 PM",
    "10:35 PM",
    "10:40 PM",
    "10:45 PM",
    "10:50 PM",
    "10:55 PM",
    "11:00 PM",
    "11:05 PM",
    "11:10 PM",
    "11:15 PM",
    "11:20 PM",
    "11:25 PM",
    "11:30 PM",
    "11:35 PM",
    "11:40 PM",
    "11:45 PM",
    "11:50 PM",
    "11:55 PM",
];

export const currencyList = [
    { currencycode: "ADP", currencyname: "ANDORAN PESTA" },
    { currencycode: "AED", currencyname: "U.A.E. Dirham" },
    { currencycode: "AFN", currencyname: "AFGAHANI" },
    { currencycode: "ALL", currencyname: "ALBANIAN LEK" },
    { currencycode: "AMD", currencyname: "ARMENIAN DRAM" },
    { currencycode: "ANG", currencyname: "NETHERLANDS ANTILLEAN GUILDER" },
    { currencycode: "AOA", currencyname: "Angolan Kwanza" },
    { currencycode: "ARS", currencyname: "Argentine Peso" },
    { currencycode: "ATS", currencyname: "AUSTRIAN SCHILLIN" },
    { currencycode: "AUD", currencyname: "Australian Dollar" },
    { currencycode: "AWG", currencyname: "ARUBAN GUILDER" },
    { currencycode: "AZM", currencyname: "AZERBAIJAN MANAT" },
    { currencycode: "AZN", currencyname: "Azerbaijani New Manats" },
    { currencycode: "BAM", currencyname: "NEW DINAR" },
    { currencycode: "BBD", currencyname: "BARBADOS DOLLAR" },
    { currencycode: "BDT", currencyname: "BANGLADESH TAKA" },
    { currencycode: "BEF", currencyname: "BELGIAN FRANC" },
    { currencycode: "BGL", currencyname: "BULGARIAN LEV" },
    { currencycode: "BGN", currencyname: "Bulgarian Lev" },
    { currencycode: "BHD", currencyname: "Bahrain Dinar" },
    { currencycode: "BIF", currencyname: "BURUNDI FRANC" },
    { currencycode: "BMD", currencyname: "BERMUDIAN DOLLAR" },
    { currencycode: "BND", currencyname: "BRUNEI DOLLAR" },
    { currencycode: "BOB", currencyname: "BOLIVIAN BOLIVIANO" },
    { currencycode: "BRL", currencyname: "Brazilian Real" },
    { currencycode: "BSD", currencyname: "BAHAMIAN DOLLAR" },
    { currencycode: "BTN", currencyname: "BHUTAN NGULTRUM" },
    { currencycode: "BWP", currencyname: "BOTSWANA PULA" },
    { currencycode: "BYB", currencyname: "BELARUSSIAN RUBLE" },
    { currencycode: "BZD", currencyname: "BELIZE DOLLAR" },
    { currencycode: "CAD", currencyname: "Canadian Dollar" },
    { currencycode: "CDF", currencyname: "Congolese Franc" },
    { currencycode: "CHF", currencyname: "Swiss Franc" },
    { currencycode: "CLF", currencyname: "Chilean Unit of Account" },
    { currencycode: "CLP", currencyname: "Chilean Peso" },
    { currencycode: "CNY", currencyname: "Chinese Yuan" },
    { currencycode: "COP", currencyname: "Colombian Peso" },
    { currencycode: "CRC", currencyname: "COSTA RICAN COLON" },
    { currencycode: "CUC", currencyname: "Cuban Peso" },
    { currencycode: "CUP", currencyname: "CUBAN PESO" },
    { currencycode: "CVE", currencyname: "CAPE VERDE ESCUDO" },
    { currencycode: "CYP", currencyname: "CYPRUS POUND" },
    { currencycode: "CZK", currencyname: "Czech Koruna" },
    { currencycode: "DEM", currencyname: "DEUTSCH MARK" },
    { currencycode: "DJF", currencyname: "DJIBOUTI FRANC" },
    { currencycode: "DKK", currencyname: "Danish Krone" },
    { currencycode: "DOP", currencyname: "DOMINICAN PESO" },
    { currencycode: "DZD", currencyname: "ALGERIAN DINAR" },
    { currencycode: "ECS", currencyname: "ECUADOR SUCRE" },
    { currencycode: "EEK", currencyname: "ESTONIAN KROON" },
    { currencycode: "EGP", currencyname: "Egyptian Pound" },
    { currencycode: "ERN", currencyname: "Eritrean Nakfa" },
    { currencycode: "ESP", currencyname: "SPANISH PESETA" },
    { currencycode: "ETB", currencyname: "ETHOPHIAN BIRR" },
    { currencycode: "EUR", currencyname: "Euro" },
    { currencycode: "FIM", currencyname: "FINISH MARKKA" },
    { currencycode: "FJD", currencyname: "Fijian Dollar" },
    { currencycode: "FKP", currencyname: "FALKLAND ISLANDSPOUND" },
    { currencycode: "FRF", currencyname: "FRENCH FRANC" },
    { currencycode: "GBP", currencyname: "Pound Sterling" },
    { currencycode: "GEL", currencyname: "Georgian Lari" },
    { currencycode: "GHS", currencyname: "Ghanaian Cedi" },
    { currencycode: "GIP", currencyname: "GIBRALTAR POUND" },
    { currencycode: "GMD", currencyname: "GAMBIAN DALASI" },
    { currencycode: "GNF", currencyname: "GUNEA FRANC" },
    { currencycode: "GRD", currencyname: "GREEK DRACHMA" },
    { currencycode: "GTQ", currencyname: "GUATEMALA QUETZAL" },
    { currencycode: "GWP", currencyname: "GUINEA-BISSAU PESO" },
    { currencycode: "GYD", currencyname: "GUYANA DOLLAR" },
    { currencycode: "HKD", currencyname: "Hong Kong Dollar" },
    { currencycode: "HNL", currencyname: "HONDURAS LEMPIRA" },
    { currencycode: "HRK", currencyname: "CROATIA KUNA" },
    { currencycode: "HTG", currencyname: "HAITI GOURDE" },
    { currencycode: "HUF", currencyname: "Hungarian Forint" },
    { currencycode: "IDR", currencyname: "Indonesian Rupiah" },
    { currencycode: "IEP", currencyname: "IRISH POUNDS" },
    { currencycode: "ILS", currencyname: "New Israeli Sheqel" },
    { currencycode: "INR", currencyname: "Indian Rupee" },
    { currencycode: "IQD", currencyname: "IRAQI DINAR" },
    { currencycode: "IRR", currencyname: "IRANIAN RIAL" },
    { currencycode: "ISK", currencyname: "ICELAND KRONA" },
    { currencycode: "ITL", currencyname: "ITALIAN LIRA" },
    { currencycode: "JMD", currencyname: "JAMAICAN DOLLAR" },
    { currencycode: "JOD", currencyname: "Jordanian Dinar" },
    { currencycode: "JPY", currencyname: "Japanese Yen" },
    { currencycode: "KES", currencyname: "KENYAN SHILLING" },
    { currencycode: "KGS", currencyname: "KYRGYZTAN SOM" },
    { currencycode: "KHR", currencyname: "CAMBODIAN REIL" },
    { currencycode: "KMF", currencyname: "COMOROS FRANC" },
    { currencycode: "KPW", currencyname: "NORTH KOREAN WON" },
    { currencycode: "KRW", currencyname: "Korean Won" },
    { currencycode: "KWD", currencyname: "Kuwaiti Dinar" },
    { currencycode: "KYD", currencyname: "CAYMAN ISLANDS DOLLAR" },
    { currencycode: "KZT", currencyname: "Kazakhstani Tenge" },
    { currencycode: "LAK", currencyname: "LAOS KIP" },
    { currencycode: "LBP", currencyname: "LEBANESE POUND" },
    { currencycode: "LKR", currencyname: "SRI LANKA RUPEE" },
    { currencycode: "LRD", currencyname: "LIBERIAN DOLLAR" },
    { currencycode: "LSL", currencyname: "LESOTHO LOTI" },
    { currencycode: "LTL", currencyname: "LITHUANIAN LITAS" },
    { currencycode: "LUF", currencyname: "LUXEMBOURG FRANCS" },
    { currencycode: "LVL", currencyname: "LATVIAN LAT" },
    { currencycode: "LYD", currencyname: "LIBYAN DINAR" },
    { currencycode: "MAD", currencyname: "MORACCAN DIRHAM" },
    { currencycode: "MDL", currencyname: "Moldovan Leu" },
    { currencycode: "MGA", currencyname: "Malagasy Ariary" },
    { currencycode: "MKD", currencyname: "MACEDONIANI DENAR" },
    { currencycode: "MMK", currencyname: "The Myanma Kyat" },
    { currencycode: "MNT", currencyname: "MONGOLIAN TUGRIK" },
    { currencycode: "MOP", currencyname: "MACAU PATACA" },
    { currencycode: "MRU", currencyname: "Mauritanian ouguiya" },
    { currencycode: "MTL", currencyname: "MALTESE LIRA" },
    { currencycode: "MUR", currencyname: "MAURITIUS RUPEE" },
    { currencycode: "MVR", currencyname: "MALDIVE RUFIYAA" },
    { currencycode: "MWK", currencyname: "MALAWIAN KWACHA" },
    { currencycode: "MXN", currencyname: "Mexican Peso" },
    { currencycode: "MYR", currencyname: "Malaysian Ringgit" },
    { currencycode: "MZM", currencyname: "MOZAMBIQUE METICAL" },
    { currencycode: "NAD", currencyname: "Namibian Dollar" },
    { currencycode: "NGN", currencyname: "NIGERIAN NAIRA" },
    { currencycode: "NIO", currencyname: "NICARAGUAN CORDOBA ORO" },
    { currencycode: "NLG", currencyname: "NETHERLANDS GUILDER" },
    { currencycode: "NOK", currencyname: "Norwegian Krone" },
    { currencycode: "NPR", currencyname: "NEPALESE RUPEE" },
    { currencycode: "NZD", currencyname: "New Zealand Dollar" },
    { currencycode: "OMR", currencyname: "Omani Rial" },
    { currencycode: "PAB", currencyname: "PANAMAN BALBOA" },
    { currencycode: "PEN", currencyname: "PERUVIAN NEUVO SOL" },
    { currencycode: "PGK", currencyname: "KINA" },
    { currencycode: "PHP", currencyname: "Philippine Peso" },
    { currencycode: "PKR", currencyname: "PAKISTANI RUPEE" },
    { currencycode: "PLN", currencyname: "Polish Zloty" },
    { currencycode: "PTE", currencyname: "PORTUGESE ESCUDO" },
    { currencycode: "PYG", currencyname: "PARAGUAY GUARANI" },
    { currencycode: "QAD", currencyname: "Qatari Riyal" },
    { currencycode: "QAR", currencyname: "Qatari Riyal" },
    { currencycode: "ROL", currencyname: "ROMANIAN LEU" },
    { currencycode: "RON", currencyname: "Romanian New Leu" },
    { currencycode: "RSD", currencyname: "Serbian dinar" },
    { currencycode: "RUB", currencyname: "Russian Ruble" },
    { currencycode: "RUR", currencyname: "ROUBLE" },
    { currencycode: "RWF", currencyname: "RWANDA FRANC" },
    { currencycode: "SAR", currencyname: "Saudi Arabian Riyal" },
    { currencycode: "SBD", currencyname: "SOLOMAN ISLANDS DOLLAR" },
    { currencycode: "SCR", currencyname: "SEYCHELLES RUPEE" },
    { currencycode: "SDD", currencyname: "SUDANESE DINAR" },
    { currencycode: "SEK", currencyname: "Swedish Krona" },
    { currencycode: "SGD", currencyname: "Singaporean Dollar" },
    { currencycode: "SHP", currencyname: "ST. HELENA POUND" },
    { currencycode: "SIT", currencyname: "SLOVENIAN TOLAR" },
    { currencycode: "SKK", currencyname: "SLOVAKI KORUNA" },
    { currencycode: "SLL", currencyname: "LEONE" },
    { currencycode: "SOS", currencyname: "SOMALI SHILLING" },
    { currencycode: "SRG", currencyname: "SURINAME GUILDER" },
    { currencycode: "SSP", currencyname: "South Sudanese Pound" },
    { currencycode: "STD", currencyname: "DOBRA" },
    { currencycode: "STN", currencyname: "São Tomé and Príncipe dobra" },
    { currencycode: "SVC", currencyname: "EL SALVADOR COLON" },
    { currencycode: "SYP", currencyname: "SYRIAN POUND" },
    { currencycode: "SZL", currencyname: "LILANGENI" },
    { currencycode: "THB", currencyname: "Thai Baht" },
    { currencycode: "TJR", currencyname: "TAJIK ROUBLE" },
    { currencycode: "TMT", currencyname: "Turkmenistani Manat" },
    { currencycode: "TND", currencyname: "TURNISIAN DINAR" },
    { currencycode: "TOP", currencyname: "PARANGA" },
    { currencycode: "TRL", currencyname: "TURKISH LIRA" },
    { currencycode: "TRY", currencyname: "Turkish Lira" },
    { currencycode: "TTD", currencyname: "TRINIDAD AND TOBAGO DOLLAR" },
    { currencycode: "TWD", currencyname: "New Taiwan Dollar" },
    { currencycode: "TZS", currencyname: "TANZANIAN SCHILLING" },
    { currencycode: "UAH", currencyname: "Ukraine Hryvnia" },
    { currencycode: "UGX", currencyname: "UGANDA SHILLING" },
    { currencycode: "USD", currencyname: "U.S. Dollar" },
    { currencycode: "UYU", currencyname: "PESO" },
    { currencycode: "UZS", currencyname: "UZBEKISTAN SUM" },
    { currencycode: "VES", currencyname: "Venezuelan bolívar" },
    { currencycode: "VND", currencyname: "Vietnamese dong" },
    { currencycode: "VUV", currencyname: "VATU" },
    { currencycode: "WST", currencyname: "TALA" },
    { currencycode: "XAF", currencyname: "CFA FRANC" },
    { currencycode: "XCD", currencyname: "EAST CARRIBEAN DOLLAR" },
    { currencycode: "XOF", currencyname: "CFA Franc BCEAO" },
    { currencycode: "XPF", currencyname: "CFP FRANCS" },
    { currencycode: "YER", currencyname: "YEMENI RIAL" },
    { currencycode: "ZAR", currencyname: "South African Rand" },
    { currencycode: "ZMW", currencyname: "Zambian Kwacha" },
    { currencycode: "ZWL", currencyname: "ZIMBABWE DOLLAR" },
];

export const revGlanceChatDescription = {
    copmSetVarianceData: `Data compares competitor rates, occupancy, ADR, and BAR for check-in dates differing in rates over two AsOfDates, showing rate differences, percentage changes, and metrics for client's property.
`,
    dashboardData: `This data analyzes hotel performance across occupancy, revenue, reservations, ratecodes, and competitor rates, offering metrics like ADR, RevPAR, cancellations, and benchmarking for optimizing revenue and booking strategies.
`,
    eventStretergyData: `This SQL script processes hotel data, aggregating metrics like OTB, pickups, forecasts, competitor rates, LY/STLY data, and event details for revenue, occupancy, and booking insights over a specified period.
`,
    highDemandData: `This query identifies the top 10 high-demand days for a hotel using occupancy trends, booking changes, day-of-week rankings, and event attendance, scoring each factor to prioritize key performance dates.`,
    lowDemandData: `The query identifies low-demand dates by comparing current vs. forecasted occupancy, considering last year's lead time trends, helping optimize pricing, promotions, and inventory for underperforming periods.
`,
    chartData: `This visualization analyzes key hotel performance metrics, including On-the-Books (OTB) reservations, occupancy forecasts (OF), capacity (CAP), effective capacity (EC), and competitive set (CompSet) rates. Bar graphs illustrate OTB bookings, while line graphs and shaded regions highlight market pricing trends and forecast accuracy. The accompanying table details occupancy percentage, group reservations, ADR, and length of stay, providing a comprehensive view of booking patterns. Key insights enable data-driven decisions for revenue optimization, competitive positioning, and strategic pricing adjustments to maximize occupancy and profitability.`,
};

export const countryList = [
    "Afghanistan",
    "Albania",
    "Algeria",
    "American Samoa",
    "Andorra",
    "Angola",
    "Anguilla",
    "Antigua and Barbuda",
    "Argentina",
    "Armenia",
    "Aruba",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bermuda",
    "Bhutan",
    "Bolivia",
    "Bonaire, Sint Eustatius and Saba",
    "Bosnia and Herzegovina",
    "Botswana",
    "Brazil",
    "British Virgin Islands",
    "Brunei",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cabo Verde",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Cayman Islands",
    "Central African Republic",
    "Chad",
    "Chile",
    "China",
    "Cocos Islands",
    "Colombia",
    "Comoros",
    "Cook Islands",
    "Costa Rica",
    "Croatia",
    "Cuba",
    "Cyprus",
    "Czechia",
    "Democratic Republic of the Congo",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Ethiopia",
    "Falkland Islands",
    "Faroe Islands",
    "Fiji",
    "Finland",
    "France",
    "French Polynesia",
    "Gabon",
    "Gambia",
    "Georgia",
    "Germany",
    "Ghana",
    "Gibraltar",
    "Greece",
    "Greenland",
    "Grenada",
    "Guadeloupe",
    "Guam",
    "Guatemala",
    "Guernsey",
    "Guinea",
    "Guinea-Bissau",
    "Guyana",
    "Haiti",
    "Honduras",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iran",
    "Iraq",
    "Ireland",
    "Isle of Man",
    "Israel",
    "Italy",
    "Jamaica",
    "Japan",
    "Jersey",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Kosovo",
    "Kuwait",
    "Kyrgyzstan",
    "Laos",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Marshall Islands",
    "Martinique",
    "Mauritania",
    "Mauritius",
    "Mayotte",
    "Micronesia",
    "Moldova",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Montserrat",
    "Morocco",
    "Mozambique",
    "Myanmar",
    "Namibia",
    "Nepal",
    "Netherlands",
    "New Caledonia",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "Niue",
    "Norfolk Island",
    "North Macedonia",
    "Northern Mariana Islands",
    "Norway",
    "Oman",
    "Pakistan",
    "Palau",
    "Palestine",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Poland",
    "Portugal",
    "Puerto Rico",
    "Qatar",
    "Republic of the Congo",
    "Romania",
    "Russia",
    "Rwanda",
    "Saint Helena, Ascension and Tris",
    "Saint Kitts and Nevis",
    "Saint Lucia",
    "Saint Pierre and Miquelon",
    "Saint Vincent and the Grenadines",
    "México",
    "Côte d'Ivoire",
    "Curaçao",
    "Saint-Martin",
    "Samoa",
    "San Marino",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Sint Maarten",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "South Korea",
    "South Sudan",
    "Spain",
    "Sri Lanka",
    "Suriname",
    "Svalbard and Jan Mayen",
    "Swaziland",
    "Sweden",
    "Switzerland",
    "Taiwan",
    "Tajikistan",
    "Tanzania",
    "Thailand",
    "Timor-Leste",
    "Togo",
    "Tonga",
    "Trinidad and Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Turks and Caicos Islands",
    "Tuvalu",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "United Kingdom",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Venezuela",
    "Vietnam",
    "Virgin Islands, U.S.",
    "Wallis and Futuna",
    "Yemen",
    "Zambia",
    "Zimbabwe",
    "Åland",
    "São Tomé and Príncipe",
    "Saint-Barthélemy",
    "Réunion",
    "United States",
];

export const compsetTypeList = [
    { label: "Primary Compset", value: "Primary Compset" },
    { label: "Secondary Compset", value: "Secondary Compset" },
];


export const noOfGuestsList = [
    { label: "1 guests", value: 1 },
    { label: "2 guests", value: 2 },
    { label: "3 guests", value: 3 },
    { label: "4 guests", value: 4 },
    { label: "5 guests", value: 5 },
    { label: "6 guests", value: 6 },
    { label: "7 guests", value: 7 },
    { label: "8 guests", value: 8 },
    { label: "9 guests", value: 9 },
    { label: "10 guests", value: 10 }
];

export const noOfNightsList = [
    { label: "1 night", value: 1 },
    { label: "2 nights", value: 2 },
    { label: "3 nights", value: 3 },
    { label: "4 nights", value: 4 },
    { label: "5 nights", value: 5 },
    { label: "6 nights", value: 6 },
    { label: "7 nights", value: 7 },
    { label: "8 nights", value: 8 },
    { label: "9 nights", value: 9 },
    { label: "10 nights", value: 10 },
    { label: "11 nights", value: 11 },
    { label: "12 nights", value: 12 },
    { label: "13 nights", value: 13 },
    { label: "14 nights", value: 14 },
    { label: "15 nights", value: 15 }
];

export const ratemetricsRoomtypes = [
    { label: "BASIC ROOM", value: 2 },
    { label: "BUNGALOW", value: 3 },
    { label: "COMFORT ROOM", value: 4 },
    { label: "EXTENDED ROOM", value: 5 },
    { label: "HOSTEL", value: 6 },
    { label: "SUITE", value: 7 }
];

export const GroupWashDummyData = [
    {
        "arrival_date": "2026-06-11",
        "departure_date": "2026-06-20",
        "stay_date": "2026-06-11",
        "block_rooms": 0,
        "otb_rooms": 0,
        "available_block": 0,
        "group_adr": 0,
        "group_revenue": 0,
        "user_wash": 0,
        "user_wash_pct": 0,
        "system_wash": "0",
        "system_wash_pct": "0",
        "asofdate": "2026-05-27 00:00:00"
    },
    {
        "arrival_date": "2026-06-11",
        "departure_date": "2026-06-18",
        "stay_date": "2026-06-11",
        "block_rooms": 0,
        "otb_rooms": 0,
        "available_block": 0,
        "group_adr": 0,
        "group_revenue": 0,
        "user_wash": 0,
        "user_wash_pct": 0,
        "system_wash": "0",
        "system_wash_pct": "0",
        "asofdate": "2026-05-27 00:00:00"
    },
    {
        "arrival_date": "2026-06-12",
        "departure_date": "2026-06-22",
        "stay_date": "2026-06-12",
        "block_rooms": 0,
        "otb_rooms": 0,
        "available_block": 0,
        "group_adr": 0,
        "group_revenue": 0,
        "user_wash": 0,
        "user_wash_pct": 0,
        "system_wash": "0",
        "system_wash_pct": "0",
        "asofdate": "2026-05-27 00:00:00"
    },
    {
        "arrival_date": "2026-06-12",
        "departure_date": "2026-06-21",
        "stay_date": "2026-06-12",
        "block_rooms": 0,
        "otb_rooms": 0,
        "available_block": 0,
        "group_adr": 0,
        "group_revenue": 0,
        "user_wash": 0,
        "user_wash_pct": 0,
        "system_wash": "0",
        "system_wash_pct": "0",
        "asofdate": "2026-05-27 00:00:00"
    },
    {
        "arrival_date": "2026-06-12",
        "departure_date": "2026-06-20",
        "stay_date": "2026-06-12",
        "block_rooms": 0,
        "otb_rooms": 0,
        "available_block": 0,
        "group_adr": 0,
        "group_revenue": 0,
        "user_wash": 0,
        "user_wash_pct": 0,
        "system_wash": "0",
        "system_wash_pct": "0",
        "asofdate": "2026-05-27 00:00:00"
    },
    {
        "arrival_date": "2026-06-12",
        "departure_date": "2026-06-19",
        "stay_date": "2026-06-12",
        "block_rooms": 0,
        "otb_rooms": 0,
        "available_block": 0,
        "group_adr": 0,
        "group_revenue": 0,
        "user_wash": 0,
        "user_wash_pct": 0,
        "system_wash": "0",
        "system_wash_pct": "0",
        "asofdate": "2026-05-27 00:00:00"
    },
    {
        "arrival_date": "2026-06-12",
        "departure_date": "2026-06-17",
        "stay_date": "2026-06-12",
        "block_rooms": 0,
        "otb_rooms": 0,
        "available_block": 0,
        "group_adr": 0,
        "group_revenue": 0,
        "user_wash": 0,
        "user_wash_pct": 0,
        "system_wash": "0",
        "system_wash_pct": "0",
        "asofdate": "2026-05-27 00:00:00"
    },
    {
        "arrival_date": "2026-06-13",
        "departure_date": "2026-06-21",
        "stay_date": "2026-06-13",
        "block_rooms": 0,
        "otb_rooms": 0,
        "available_block": 0,
        "group_adr": 0,
        "group_revenue": 0,
        "user_wash": 0,
        "user_wash_pct": 0,
        "system_wash": "0",
        "system_wash_pct": "0",
        "asofdate": "2026-05-27 00:00:00"
    },
    {
        "arrival_date": "2026-06-13",
        "departure_date": "2026-06-20",
        "stay_date": "2026-06-13",
        "block_rooms": 0,
        "otb_rooms": 0,
        "available_block": 0,
        "group_adr": 0,
        "group_revenue": 0,
        "user_wash": 0,
        "user_wash_pct": 0,
        "system_wash": "0",
        "system_wash_pct": "0",
        "asofdate": "2026-05-27 00:00:00"
    },
    {
        "arrival_date": "2026-06-13",
        "departure_date": "2026-06-19",
        "stay_date": "2026-06-13",
        "block_rooms": 0,
        "otb_rooms": 0,
        "available_block": 0,
        "group_adr": 0,
        "group_revenue": 0,
        "user_wash": 0,
        "user_wash_pct": 0,
        "system_wash": "0",
        "system_wash_pct": "0",
        "asofdate": "2026-05-27 00:00:00"
    },
    {
        "arrival_date": "2026-06-13",
        "departure_date": "2026-06-18",
        "stay_date": "2026-06-13",
        "block_rooms": 0,
        "otb_rooms": 0,
        "available_block": 0,
        "group_adr": 0,
        "group_revenue": 0,
        "user_wash": 0,
        "user_wash_pct": 0,
        "system_wash": "0",
        "system_wash_pct": "0",
        "asofdate": "2026-05-27 00:00:00"
    },
    {
        "arrival_date": "2026-06-13",
        "departure_date": "2026-06-17",
        "stay_date": "2026-06-13",
        "block_rooms": 0,
        "otb_rooms": 0,
        "available_block": 0,
        "group_adr": 0,
        "group_revenue": 0,
        "user_wash": 0,
        "user_wash_pct": 0,
        "system_wash": "0",
        "system_wash_pct": "0",
        "asofdate": "2026-05-27 00:00:00"
    },
    {
        "arrival_date": "2026-06-14",
        "departure_date": "2026-06-20",
        "stay_date": "2026-06-14",
        "block_rooms": 0,
        "otb_rooms": 0,
        "available_block": 0,
        "group_adr": 0,
        "group_revenue": 0,
        "user_wash": 0,
        "user_wash_pct": 0,
        "system_wash": "0",
        "system_wash_pct": "0",
        "asofdate": "2026-05-27 00:00:00"
    },
    {
        "arrival_date": "2026-06-14",
        "departure_date": "2026-06-19",
        "stay_date": "2026-06-14",
        "block_rooms": 0,
        "otb_rooms": 0,
        "available_block": 0,
        "group_adr": 0,
        "group_revenue": 0,
        "user_wash": 0,
        "user_wash_pct": 0,
        "system_wash": "0",
        "system_wash_pct": "0",
        "asofdate": "2026-05-27 00:00:00"
    },
    {
        "arrival_date": "2026-06-15",
        "departure_date": "2026-06-20",
        "stay_date": "2026-06-15",
        "block_rooms": 0,
        "otb_rooms": 0,
        "available_block": 0,
        "group_adr": 0,
        "group_revenue": 0,
        "user_wash": 0,
        "user_wash_pct": 0,
        "system_wash": "0",
        "system_wash_pct": "0",
        "asofdate": "2026-05-27 00:00:00"
    },
    {
        "arrival_date": "2026-06-16",
        "departure_date": "2026-06-20",
        "stay_date": "2026-06-16",
        "block_rooms": 0,
        "otb_rooms": 0,
        "available_block": 0,
        "group_adr": 0,
        "group_revenue": 0,
        "user_wash": 0,
        "user_wash_pct": 0,
        "system_wash": "0",
        "system_wash_pct": "0",
        "asofdate": "2026-05-27 00:00:00"
    },
    {
        "arrival_date": "2026-06-17",
        "departure_date": "2026-06-20",
        "stay_date": "2026-06-17",
        "block_rooms": 0,
        "otb_rooms": 0,
        "available_block": 0,
        "group_adr": 0,
        "group_revenue": 0,
        "user_wash": 0,
        "user_wash_pct": 0,
        "system_wash": "0",
        "system_wash_pct": "0",
        "asofdate": "2026-05-27 00:00:00"
    },
    {
        "arrival_date": "2026-06-18",
        "departure_date": "2026-06-21",
        "stay_date": "2026-06-18",
        "block_rooms": 0,
        "otb_rooms": 0,
        "available_block": 0,
        "group_adr": 0,
        "group_revenue": 0,
        "user_wash": 0,
        "user_wash_pct": 0,
        "system_wash": "0",
        "system_wash_pct": "0",
        "asofdate": "2026-05-27 00:00:00"
    }
];